module.exports = __webpack_public_path__ + "cross.9ce17e061e70fda92f0484c1e2914f28.cache.svg";